<template>
    <h1>Gestão de Avaliações</h1>

    <AssessmentActivationStatusForm

    />

    <AssessmentActivationStatusManagementTable

    />
</template>

<script setup>
import AssessmentActivationStatusForm from '../../components/assessments/manage/AssessmentActivationStatusForm.vue';
import AssessmentActivationStatusManagementTable from '../../components/assessments/manage/AssessmentActivationStatusManagementTable.vue';


</script>